import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const AUTH_EVENT_NAMES = {
  SESSION_START: 'session_start',
  CSP_LOGIN: 'csp_user_login_successfully',
  SSO_CSP_LOGIN: 'sso_csp_user_login_successfully',
  RESET_PASSWORD: 'user_reset_password',
  CHANGED_PASSWORD: 'user_changed_password',
  SSO_LOGIN: 'sso_login',
};

export const trackSessionStart = () => {
  gspx.trackEvent({
    name: AUTH_EVENT_NAMES.SESSION_START,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.NAVBAR,
    additionalKeys: {
      legacy_category: 'Auth Session',
      legacy_name: 'Session Start',
      Category: 'Session tracking',
      'Launched date': new Date(),
    },
  });
};

export const trackCSPlogin = () => {
  gspx.trackEvent({
    name: AUTH_EVENT_NAMES.CSP_LOGIN,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: 'CSP user login successfully',
      Category: 'Alert',
      'Launched date': new Date(),
    },
  });
};

/**
 * LEGACY: Track NS SSO login for CSP. This is a custom event for CSP users
 * predating the implementation of our general purpose SSO login project.
 * Consider this a legacy event. For SSO login tracking use trackSSOLogin().
 */
export const trackNSLoginForCSP = () => {
  gspx.trackEvent({
    name: AUTH_EVENT_NAMES.SSO_CSP_LOGIN,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: 'SSO CSP user login successfully',
      Category: 'Alert',
      'Launched date': new Date(),
    },
  });
};

export const trackRequestResetPasswordSuccess = () => {
  gspx.trackEvent({
    name: AUTH_EVENT_NAMES.RESET_PASSWORD,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.NAVBAR,
    additionalKeys: {
      legacy_category: 'Auth',
      legacy_name: 'User reset password',
      Category: 'Auth',
      'Launched date': new Date(),
    },
  });
};

export const trackChangedPasswordSuccess = () => {
  gspx.trackEvent({
    name: AUTH_EVENT_NAMES.CHANGED_PASSWORD,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.NAVBAR,
    additionalKeys: {
      legacy_category: 'Auth',
      legacy_name: 'User changed password',
      Category: 'Auth',
      'Launched date': new Date(),
    },
  });
};

export const trackSSOLogin = (appName = '') => {
  gspx.trackEvent({
    name: AUTH_EVENT_NAMES.SSO_LOGIN,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.NAVBAR,
    additionalKeys: {
      legacy_category: 'Auth',
      legacy_name: `SSO login ${appName}`,
      Category: 'Auth',
      'Launched date': new Date(),
    },
  });
};
